// @ts-nocheck
import { gioClick } from '@/utils/gioApi';
import { getCommonParams } from '@/utils/gioIndex';
const dataDelicacyGio = {};

export function setDataGioList(goods) {
  if (Array.isArray(goods)) {
    goods.forEach((good) => {
      const value = dataDelicacyGio[good.brandName];
      dataDelicacyGio[good.brandName] = value ? value : false;
    });
  }
}

export function clearGioStatus() {
  for (var key in dataDelicacyGio) {
    dataDelicacyGio[key] = false;
  }
  // console.log('dataDelicacyGio', dataDelicacyGio);
}

export function changeGioFlag(goodid, flag) {
  dataDelicacyGio[goodid] = flag ? true : false;
}

export function checkExposureGio(goods) {
  if (!goods || goods.length < 0) {
    return;
  }

  let len = goods.length;
  // 计算页面置顶元素高度
  let minusTop = window.innerWidth * 0.228;
  let minusLeft = window.innerWidth * 0.04;
  for (var i = 0; i < len; i++) {
    let $dom = document.getElementById(`audioItem${i}`);
    const { brandName } = goods[i] || {};
    if ($dom) {
      const offset = $dom.getBoundingClientRect();
      const offsetTop = offset.top;
      const offsetBottom = offset.bottom;
      const offsetLeft = offset.left;
      const offsetRight = offset.right;
      // 进入可视区域（可视区域还需要减去置顶和置底元素的高度）
      if (offsetTop <= window.innerHeight && offsetBottom >= minusTop && offsetLeft < window.innerWidth && offsetRight > minusLeft) {
        // console.log(`这是第${i + 1}个元素`, offsetTop, offsetBottom, offsetLeft, offsetRight, dataDelicacyGio);
        // 若当前进入可视区域的元素本身可视状态为false
        if (!dataDelicacyGio[brandName]) {
          // 更新当前的埋点曝光gioIng状态
          changeGioFlag(brandName, true);
          try {
              gioClick('电影-频道首页', {
                pagename: '电影首页',
                modulename: '直充会员',
                elementname: '直充会员',
                contentTitle: goods?.[i]?.brandName,
                floorNum: 5,
                HPbanenrNum: i+1,
                JumpAddress: goods?.[i]?.url,
                content: goods?.[i]?.discountTag,
                channle: '电影'
              }, 'DF_exposureEvent');
          } catch (error) {
            console.error(error);
          }
        }
      } else {
        // 非可视区域统一更新当前的埋点曝光gioIng状态
        if (dataDelicacyGio[brandName]) {
          changeGioFlag(brandName, false);
        }
      }
    }
  }
}
